import { PRODUCT_NAME_AI_AGENT_PLAN_STANDARD } from '@base/settings';
import { useAgentPlan } from './useAgentPlan';

export const useStandardAgentPlan = () => {
  return useAgentPlan({
    planName: PRODUCT_NAME_AI_AGENT_PLAN_STANDARD,
  });
};
